export default "__VITE_ASSET__LqWbt4UE__"